import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Reseller } from "../models/Reseller/Reseller";
import { ResellerFilter } from "../models/Reseller/ResellerFilter";
import { Page } from "../shared/models/Page";
import { PagedResponse } from "../shared/models/PagedResponse";
import { Response } from "../shared/models/Response";
import { Emisor } from "../models/Emisor/Emisor";
import { ResumenReseller } from "../models/Reseller/ResumenReseller";
import { PlanFacturacion } from "../models/PlanesUsuario/PlanFacturacion";
import { Data } from "@angular/router";

@Injectable({
	providedIn: "root",
})
export class ResellerService {
	private REST_API_SERVER = environment.backend_server + "/Reseller";
	constructor(private http: HttpClient) {}

	public getResumenReseller(resellerId: String): Observable<ResumenReseller> {
		return this.http.get<ResumenReseller>(this.REST_API_SERVER + "/planes/resumen/" + resellerId);
	}
	public getPlanesByResellerByPage(page: Page, resellerId: String, anio: number, mes: number, periodo: String): Observable<PagedResponse<Emisor>> {
		return this.http.get<PagedResponse<Emisor>>(this.REST_API_SERVER + "/planes/list/filter/" + resellerId + "?anio=" + anio + "&mes=" + mes + "&periodo=" + periodo + "&pageNumber=" + page.pageNumber + "&pageSize=" + page.pageSize);
	}

	public getFacturasByResellerByPage(page: Page, resellerId: String): Observable<PagedResponse<PlanFacturacion>> {
		return this.http.get<PagedResponse<PlanFacturacion>>(this.REST_API_SERVER + "/facturas/" + resellerId + "?pageNumber=" + page.pageNumber + "&pageSize=" + page.pageSize);
	}

	getFacturaPDF(idFactura: string): Observable<Response<any>> {
		return this.http.get<Response<any>>(this.REST_API_SERVER + "/facturas/pdf/" + idFactura);
	}

	getDataByPage(filter: ResellerFilter, page: Page) {
		return this.http.get<PagedResponse<Reseller>>(this.REST_API_SERVER + "/list/filter" + "?razonSocial=" + (filter.razonSocial != undefined ? filter.razonSocial : "") + "&nombreContacto=" + (filter.nombreContacto != undefined ? filter.nombreContacto : "") + "&rut=" + (filter.rut != undefined ? filter.rut : "") + "&activo=" + (filter.activo != undefined ? filter.activo : true) + "&pageNumber=" + page.pageNumber + "&pageSize=" + page.pageSize);
	}

	addReseller(request: Reseller): Observable<Response<boolean>> {
		let formData = new FormData();
		formData.append("file", request.logoCompleteFile);
		formData.append("resellerString", JSON.stringify(request));
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/add", formData);
	}

	editReseller(request: Reseller): Observable<Response<boolean>> {
		let formData = new FormData();
		formData.append("file", request.logoCompleteFile);
		formData.append("resellerString", JSON.stringify(request));
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/update", formData);
	}

	deactivateReseller(request: Reseller) {
		return this.http.get<Response<boolean>>(this.REST_API_SERVER + "/deactivate/" + request.resellerId);
	}

	reactivateReseller(request: Reseller) {
		return this.http.get<Response<boolean>>(this.REST_API_SERVER + "/activate/" + request.resellerId);
	}

	assignEmisores(reseller: Reseller, emisorIdList: string[]) {
		let formData = new FormData();
		formData.append("resellerId", reseller.resellerId);
		formData.append("emisoresIdsString", JSON.stringify(emisorIdList));
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/assignCompanies", formData);
	}

	unassignEmisores(reseller: Reseller, emisorIdList: string[]) {
		let formData = new FormData();
		formData.append("resellerId", reseller.resellerId);
		formData.append("emisoresIdsString", JSON.stringify(emisorIdList));
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/unassignCompanies", formData);
	}
	uploadLogo(resellerId: string, file: File) {
		const form = new FormData();
		form.append('file', file);
		form.append('resellerId', resellerId);
		return this.http.post<Response<string>>(this.REST_API_SERVER + `/logo/${resellerId}`, form);
	}

	solicitarCertificacion(resellerId: string, emisorId: string, codigoCertificacion: number): Observable<Response<boolean>> {
		const form = new FormData();
		form.append("resellerId", resellerId);
		form.append("emisorId", emisorId);
		form.append("codigoCertificacion", codigoCertificacion.toString());
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/certificaciones/solicitar", form);
	}
}
